export default __webpack_public_path__ + "static/media/DICS.d3a533cd.png";